module.exports = __webpack_public_path__ + "static/media/OrangeAI_Logo.584a7a74.png";